import type { Keys, Values } from 'common/types'

/**
 * При изменении роутов здесь, их также нужно поменять
 * в конфиге webpack (webpack.dev.common.js) и конфиге nginx (default.conf)
 */
export const SignalRUrls = {
  MlHub: '/mlCalcAdapterSignalR',
  ProjectsHub: '/projectSignalR',
  ObjectTreeHub: '/objectTreeSignalR',
  GeoImportWorksHub: '/geoImportWorksSignalR',
  PickerProgressHub: '/pickerProgressSignalR',
  SeismicImportProgressHub: '/seismicImportProgressSignalR',
} as const

export type Hubs = Keys<typeof SignalRUrls>
export type HubUrls = Values<typeof SignalRUrls>
